<div class="ws-section__header__actions__item">
    <div
        helpTooltip
        [hasIcon]="!isReadOnly"
        position="top"
        [contentComponent]="dynamicFieldBehaviorTooltip">
        <small>Property Characteristics Behavior:</small>
    </div>
    @if (isReadOnly) {
        <div style="padding-left: 10px;"
             helpTooltip
             [hasIcon]="showFieldOptionsTooltip"
             position="top"
             [contentComponent]="dynamicFieldSelectedBehaviorTooltip">
            <small>{{ selectedPropertyCharacteristicOptionName }}</small>
        </div>
    }
    @if (!isReadOnly) {
        <div dropdown container="body" placement="bottom right">
            <button id="button-basic-characteristics"
                    dropdownToggle
                    type="button"
                    class="ace-btn btn-link btn-sm dropdown-toggle"
                    aria-controls="dropdown-basic">
                {{ selectedImportDynamicFieldBehavior?.name }}
                <span class="caret"></span>
            </button>
            <ul id="dropdown-basic-characteristics"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-end"
                role="menu"
                aria-labelledby="button-basic">
                @for (item of availableDynamicFieldBehaviorOptions; track item) {
                    <li role="menuItem">
                        <a class="dropdown-item btn-sm"
                           href="javascript:void(0);"
                           (click)="setDynamicFieldBehavior(item.optionId)">{{ item.name }}</a>
                    </li>
                }
            </ul>
        </div>
    }
    @if (!isReadOnly) {
        <button [disabled]="!canEditDynamicFieldConfiguration"
                type="button"
                class="ace-btn btn-sm btn-primary"
                (click)="editDynamicFieldBehavior()"
                helpTooltip
                helpContentId="app.edit"
                position="bottom"
        >
            <i class="fa fa-pencil"></i>
        </button>
    }
</div>
